export default "__VITE_ASSET__hDQsXxaY__"